import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
  useLocation,
} from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  countriesWithData,
  subscriptionPlans,
  subscriptionIntervals,
  API_URL,
} from "../redux/constants";
import { UserActions, createOrganization } from "../redux/UserActions";
import { Link } from "react-router-dom";
import Button from "./Helper/Button";
import Input from "./Helper/Input";
import Radio from "./Helper/Radio";
import ListBox from "./Helper/ListBox";
import PageTitle from "./General/PageTitle";

function CreateAccount() {
  const dispatch = useDispatch();

  const userState = useSelector((state) => state.user);

  const [user, setUser] = useState({
    mail: "",
    password: "",
    confirmPassword: "",
    firstName: "",
    lastName: "",
  });

  const [organization, setOrganization] = useState({
    name: "",
    contact: { mail: user.mail, phone: "", country: "+61" },
    location: { country: "Australia", address: "" },
  });

  const [paymentProcess, setPaymentProcess] = useState({
    employees: 0,
    paymentInterval: 0,
  });

  const [error, setError] = useState("");
  const [step, setStep] = useState(0);

  function validateEmail(email) {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  function registerUser() {
    setError("");
    console.log(user);
    if (!validateEmail(user["mail"])) setError("Invalid Email!");
    else if (user["firstName"] === "") setError("Enter First Name!");
    else if (user["lastName"] === "") setError("Enter Last Name!");
    else if (user["password"] != user["confirmPassword"])
      setError("Passwords don't match!");
    else {
      delete user["confirmPassword"];
      setOrganization({
        ...organization,
        contact: { ...organization.contact, mail: user.mail },
      });
      fetch(API_URL + "register", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(user),
      })
        .catch((e) => {
          let val = e.error();
          console.log(val);
        })
        .then((response) => {
          let val = response.json();
          console.log(val);
          setStep(step + 1);
        });
    }
  }

  function registerOrganization() {
    setError("");
    fetch(API_URL + "organizations", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(organization),
    })
      .then((response) => {
        let val = response.json();
        console.log(val);
        setStep(step + 1);
      })
      .catch((response) => {
        console.log(response);
      });
  }

  console.log(paymentProcess);
  useEffect(() => {
    if (
      userState.stripeCheckout &&
      Object.keys(userState.stripeCheckout).length > 0
    )
      window.location = userState.stripeCheckout.url;
  }, [userState.stripeCheckout]);

  return (
    <div className="flex w-full items-center min-h-screen bg-gray-50 dark:bg-gray-900">
      <div className="flex max-w-4xl h-full w-full md:h-auto md:mx-auto justify-center overflow-hidden bg-white md:rounded-lg shadow-xl dark:bg-gray-800">
        <div className="flex flex-col w-full overflow-y-auto md:flex-row">
          <div className="h-32 md:h-auto md:w-1/2">
            <img
              aria-hidden="true"
              className="object-cover w-full h-full"
              src={"https://i.imgur.com/nmYRaw5.png"}
              alt="Office"
            />
          </div>
          <main className="flex flex-col w-full gap-y-1 justify-center p-6 sm:p-12 md:w-1/2">
            {error === "" ? null : (
              <>
                <label className="text-center font-medium text-black py-2 w-full bg-red-500 rounded-md h-10">
                  {error}
                </label>
              </>
            )}
            {step == 0 && (
              <CreateAccountCard
                user={user}
                setUser={setUser}
                registerUser={() => registerUser()}
                addStep={() => setStep(step + 1)}
              />
            )}

            {step == 1 && (
              <CreateOrganizationCard
                user={user}
                organization={organization}
                setOrganization={setOrganization}
                registerOrganization={() => registerOrganization()}
              />
            )}
            {step == 2 ? (
              <>
                <h1 className="mb-4 text-xl font-semibold text-gray-700 dark:text-gray-200">
                  Select Organisation Size
                </h1>

                <Button
                  className="w-full p-2"
                  label="1-4 Employees"
                  handleClick={(e) => {
                    setPaymentProcess({
                      ...paymentProcess,
                      employees: e.target.value,
                    });
                  }}
                />
                <Button
                  className="w-full p-2"
                  label="5-19 Employees"
                  handleClick={() => {}}
                />
                <Button
                  className="w-full p-2"
                  label="20-199 Employees"
                  handleClick={() => {}}
                />
                <Button
                  className="w-full p-2"
                  label="200-999 Employees"
                  handleClick={() => {}}
                />
                <Button
                  className="w-full p-2"
                  label="1000+ Employees"
                  handleClick={() => {}}
                />

                <Link
                  className="my-2 py-2 w-full text-center text-white font-medium rounded bg-indigo-800"
                  onClick=""
                >
                  Continue
                </Link>
              </>
            ) : null}
            {step == 3 ? (
              <>
                <h1 className="mb-4 text-xl font-semibold text-gray-700 dark:text-gray-200">
                  Select Organisation Size
                </h1>

                <Button
                  className="w-full p-2"
                  label="Invoice"
                  handleClick={() => {}}
                />
                <Button
                  className="w-full p-2"
                  label="Card"
                  handleClick={() => {}}
                />

                <Button
                  className="my-2 py-2 w-full text-center text-white font-medium rounded bg-indigo-800"
                  onClick=""
                >
                  Continue
                </Button>
              </>
            ) : null}
            {step == 4 ? (
              <>
                <h1 className="mb-4 text-xl font-semibold text-gray-700 dark:text-gray-200">
                  Organisation Created!
                </h1>

                <Link
                  className="my-2 py-2 w-full text-center text-white font-medium rounded bg-indigo-800"
                  to="/login"
                >
                  Continue to Login
                </Link>
              </>
            ) : null}
            <hr className="my-3" />
            <Link
              className="text-sm w-full font-medium text-center text-purple-600 dark:text-purple-400 hover:underline"
              to="/login"
            >
              Already have an organization? Login
            </Link>
          </main>
        </div>
      </div>
    </div>
  );
}

export default CreateAccount;

function CreateAccountCard(props) {
  return (
    <>
      <PageTitle>Create an Account</PageTitle>
      <div className="flex items-center gap-x-2">
        <Input
          handleChange={(e) =>
            props.setUser({ ...props.user, firstName: e.target.value })
          }
          placeholder="Name"
          type="text"
          label="First Name"
        />
        <Input
          handleChange={(e) =>
            props.setUser({ ...props.user, lastName: e.target.value })
          }
          placeholder="Surname"
          type="text"
          label="Last Name"
        />
      </div>
      <Input
        handleChange={(e) =>
          props.setUser({ ...props.user, mail: e.target.value })
        }
        placeholder="Email Address"
        type="email"
        label="Mail"
      />
      <Input
        handleChange={(e) =>
          props.setUser({ ...props.user, password: e.target.value })
        }
        placeholder="Password"
        type="password"
        label="Password"
      />
      <Input
        handleChange={(e) =>
          props.setUser({ ...props.user, confirmPassword: e.target.value })
        }
        placeholder="Confirm Password"
        type="password"
        label="Confirm Password"
      />

      <div className="my-2" />

      <Button
        className="my-2 py-3 w-full bg-green-600"
        label="Continue"
        handleClick={(e) => {
          props.registerUser();
        }}
      />

      <label
        className="text-sm  w-full font-medium text-right text-blue-600 dark:text-purple-400 hover:underline"
        onClick={(e) => {
          props.addStep();
        }}
      >
        Already have an account? Skip
      </label>
    </>
  );
}

function CreateOrganizationCard(props) {
  return (
    <>
      <PageTitle>Create Organisation</PageTitle>

      <Input
        handleChange={(e) =>
          props.setOrganization({ ...props.organization, name: e.target.value })
        }
        placeholder="Organization Name"
        type="text"
        label="Name"
      />
      <Input
        handleChange={(e) =>
          props.setOrganization({
            ...props.organization,
            contact: { ...props.organization.contact, mail: e.target.value },
          })
        }
        defaultValue={props.organization.contact.mail}
        placeholder="Admin Email"
        type="text"
        label="Email"
      />
      <div className="flex items-center w-fuls gap-x-2">
        <ListBox
          className=""
          options={countriesWithData.map((country) => "+" + country.phone)}
          selected={props.organization.contact.country}
          default={props.organization.contact.country}
          _handleSelected={(e) =>
            props.setOrganization({
              ...props.organization,
              contact: { ...props.organization.contact, country: e },
            })
          }
        />
        <Input
          className="w-full"
          handleChange={(e) =>
            props.setOrganization({
              ...props.organization,
              contact: { ...props.organization.contact, phone: e.target.value },
            })
          }
          placeholder="Contact Phone"
          type="text"
          label="Phone"
        />
      </div>
      <div className="flex items-center w-full gap-x-2">
        <ListBox
          className=""
          options={countriesWithData.map((country) => country.name)}
          selected={props.organization.location.country}
          default={props.organization.location.country}
          _handleSelected={(e) =>
            props.setOrganization({
              ...props.organization,
              location: { ...props.organization.location, country: e },
            })
          }
        />
        <Input
          handleChange={(e) =>
            props.setOrganization({
              ...props.organization,
              location: {
                ...props.organization.location,
                address: e.target.value,
              },
            })
          }
          placeholder="Physical Address"
          type="text"
          label="Address"
        />
      </div>

      <Button
        className="my-2 py-2 w-full bg-indigo-800"
        label="Continue"
        handleClick={(e) => props.registerOrganization()}
      />
    </>
  );
}
